import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  mobileSidebarOpened: false,
  showProjectListMenu: false,
};

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    toggleMobileSidebarOpened: (state, action) => {
      const nextState =
        typeof action.payload === 'undefined'
          ? !state.mobileSidebarOpened
          : action.payload;
      return {
        ...state,
        mobileSidebarOpened: nextState,
        showProjectListMenu: false,
      };
    },
    setShowProjectList: (state) => {
      return {
        ...state,
        showProjectListMenu: true,
      };
    },
  },
});

export default appSettingsSlice.reducer;

// Actions
export const { toggleMobileSidebarOpened, setShowProjectList } =
  appSettingsSlice.actions;

// Selectors
export const getMobileSidebarOpened = (state) =>
  state.appSettings.mobileSidebarOpened;
export const showProjectListMenu = (state) =>
  state.appSettings.showProjectListMenu;
